import * as React from "react"
import { Logo } from "@/components/Logo"

// Clean checkout/recovery layout: no site navigation, logo only.
export function CheckoutShell({
  children,
  maxWidth = "max-w-xl",
}: {
  children: React.ReactNode
  maxWidth?: string
}) {
  return (
    <div className="min-h-screen bg-page text-ink-body">
      <header className="flex justify-center pt-10 pb-6">
        <Logo className="h-9" />
      </header>
      <main className={`mx-auto w-full ${maxWidth} px-4 pb-16`}>{children}</main>
    </div>
  )
}
